<p class="header">{{ 'stt.download.pdf' | translate }}</p>
<div class="content">
    <div class="col md-12">
        <span class="material-icons sound">
        get_app
        </span> 
    </div>
    <p>{{ 'stt.download.down' | translate }}</p>
    <P>{{ 'stt.download.confirm' | translate }}</P>

    <div class="buttons-box">
        <a class="button-primary no" (click)="closeModal(false)"  mat-dialog-close>{{ 'stt.download.not' | translate }}</a> 
        <a class="button-primary" (click)="handlerDownload()" mat-dialog-close>{{ 'stt.download.yes' | translate }}</a>
    </div>
</div>
